// Events page data with image requires
export function getEventsData() {
  return {
    heading: "Events",
    description: "Take part in exclusive fitness events, transformation challenges, and expert-led workshops designed to elevate your training experience.",
    headerImage: require("../assets/event/event-frstsec.jpg"),
    events: [
      {
        id: 1,
        title: "KLBC",
        images: [
          require("../assets/event/klbc/img1.jpg"),
          require("../assets/event/klbc/img2.jpg"),
          require("../assets/event/klbc/img3.jpg"),
          require("../assets/event/klbc/img4.jpg"),
          require("../assets/event/klbc/img5.jpg"),
        ]
      },
      {
        id: 2,
        title: "KEJOHANAN TAEKWON-DO ITF PIALA SERDANG 2025",
        images: [
          require("../assets/event/taekwondo/img1.jpg"),
          require("../assets/event/taekwondo/img2.jpg"),
          require("../assets/event/taekwondo/img3.jpg"),
          require("../assets/event/taekwondo/img4.jpg"),
          require("../assets/event/taekwondo/img5.jpg"),
          require("../assets/event/taekwondo/img6.jpg"),
          require("../assets/event/taekwondo/img7.jpg"),
          require("../assets/event/taekwondo/img8.jpg"),
          require("../assets/event/taekwondo/img9.jpg"),
          require("../assets/event/taekwondo/img10.jpg"),
          require("../assets/event/taekwondo/img11.jpg"),
          require("../assets/event/taekwondo/img12.jpg"),
          require("../assets/event/taekwondo/img13.jpg"),
          require("../assets/event/taekwondo/img14.jpg"),
          require("../assets/event/taekwondo/img15.jpg"),
          require("../assets/event/taekwondo/img16.jpg"),
          require("../assets/event/taekwondo/img17.jpg"),
          require("../assets/event/taekwondo/img18.jpg"),
          require("../assets/event/taekwondo/img19.jpg"),
          require("../assets/event/taekwondo/img20.jpg"),
          require("../assets/event/taekwondo/img21.jpg"),
          require("../assets/event/taekwondo/img22.jpg"),
          require("../assets/event/taekwondo/img23.jpg"),
          require("../assets/event/taekwondo/img24.jpg"),
          require("../assets/event/taekwondo/img25.jpg"),
          require("../assets/event/taekwondo/img26.jpg"),
          require("../assets/event/taekwondo/img27.jpg"),
          require("../assets/event/taekwondo/img28.jpg"),
          require("../assets/event/taekwondo/img29.jpg"),
          require("../assets/event/taekwondo/img37.jpg"),
          require("../assets/event/taekwondo/img30.jpg"),
          require("../assets/event/taekwondo/img31.jpg"),
          require("../assets/event/taekwondo/img32.jpg"),
          require("../assets/event/taekwondo/img33.jpg"),
          require("../assets/event/taekwondo/img34.jpg"),
          require("../assets/event/taekwondo/img35.jpg"),
          require("../assets/event/taekwondo/img36.jpg"),
        ]
      },
      {
        id: 3,
        title: "PUTRAJAYA TAEKWON-DO CHAMPIONSHIP 2022",
        images: [
          require("../assets/event/champ2022/img1.jpg"),
          require("../assets/event/champ2022/img2.jpg"),
          require("../assets/event/champ2022/img3.jpg"),
          require("../assets/event/champ2022/img4.jpg"),
          require("../assets/event/champ2022/img5.jpg"),
          require("../assets/event/champ2022/img6.jpg"),
          require("../assets/event/champ2022/img7.jpg"),
          require("../assets/event/champ2022/img8.jpg"),
          require("../assets/event/champ2022/img9.jpg"),
          require("../assets/event/champ2022/img10.jpg"),
          require("../assets/event/champ2022/img11.jpg"),
        ]
      },
      {
        id: 4,
        title: "PUTRAJAYA TAEKWON-DO CHAMPIONSHIP 2023",
        images: [
          require("../assets/event/champ2023/img1.jpg"),
          require("../assets/event/champ2023/img2.jpg"),
          require("../assets/event/champ2023/img3.jpg"),
          require("../assets/event/champ2023/img4.jpg"),
          require("../assets/event/champ2023/img5.jpg"),
          require("../assets/event/champ2023/img6.jpg"),
          require("../assets/event/champ2023/img7.jpg"),
          require("../assets/event/champ2023/img8.jpg"),
          require("../assets/event/champ2023/img9.jpg"),
          require("../assets/event/champ2023/img10.jpg"),
          require("../assets/event/champ2023/img11.jpg"),
        ]
      },
      {
        id: 5,
        title: "SJKC KUANG SPORTS DAYS",
        images: [
          require("../assets/event/kuang/img1.jpg"),
          require("../assets/event/kuang/img2.jpg"),
          require("../assets/event/kuang/img3.jpg"),
          require("../assets/event/kuang/img4.jpg"),
          require("../assets/event/kuang/img5.jpg"),
          require("../assets/event/kuang/img6.jpg"),
          require("../assets/event/kuang/img7.jpg"),
          require("../assets/event/kuang/img8.jpg"),
          require("../assets/event/kuang/img9.jpg"),
          require("../assets/event/kuang/img10.jpg"),
          require("../assets/event/kuang/img11.jpg"),
          require("../assets/event/kuang/img12.jpg"),
          require("../assets/event/kuang/img13.jpg"),
          require("../assets/event/kuang/img14.jpg"),
          require("../assets/event/kuang/img15.jpg"),
          require("../assets/event/kuang/img16.jpg"),
          require("../assets/event/kuang/img17.jpg"),
          require("../assets/event/kuang/img18.jpg"),
          require("../assets/event/kuang/img19.jpg"),
        ]
      },
      {
        id: 6,
        title: "PUTRAJAYA TAEKWON-DO CHAMPIONSHIP 2025",
        images: [
          require("../assets/event/champ2025/img1.jpg"),
          require("../assets/event/champ2025/img2.jpg"),
          require("../assets/event/champ2025/img3.jpg"),
          require("../assets/event/champ2025/img4.jpg"),
          require("../assets/event/champ2025/img5.jpg"),
          require("../assets/event/champ2025/img6.jpg"),
          require("../assets/event/champ2025/img7.jpg"),
          require("../assets/event/champ2025/img8.jpg"),
          require("../assets/event/champ2025/img9.jpg"),
          require("../assets/event/champ2025/img10.jpg"),
          require("../assets/event/champ2025/img11.jpg"),
          require("../assets/event/champ2025/img12.jpg"),
          require("../assets/event/champ2025/img13.jpg"),
          require("../assets/event/champ2025/img14.jpg"),
          require("../assets/event/champ2025/img15.jpg"),
          require("../assets/event/champ2025/img16.jpg"),
          require("../assets/event/champ2025/img17.jpg"),
          require("../assets/event/champ2025/img18.jpg"),
          require("../assets/event/champ2025/img19.jpg"),
          require("../assets/event/champ2025/img20.jpg"),
          require("../assets/event/champ2025/img21.jpg"),
          require("../assets/event/champ2025/img22.jpg"),
          require("../assets/event/champ2025/img23.jpg"),
          require("../assets/event/champ2025/img24.jpg"),
          require("../assets/event/champ2025/img25.jpg"),
          require("../assets/event/champ2025/img26.jpg"),
          require("../assets/event/champ2025/img27.jpg"),
          require("../assets/event/champ2025/img28.jpg"),
          require("../assets/event/champ2025/img29.jpg"),
          require("../assets/event/champ2025/img30.jpg"),
          require("../assets/event/champ2025/img31.jpg"),
          require("../assets/event/champ2025/img32.jpg"),
          require("../assets/event/champ2025/img33.jpg"),
          require("../assets/event/champ2025/img34.jpg"),
          require("../assets/event/champ2025/img35.jpg"),
          require("../assets/event/champ2025/img36.jpg"),
          require("../assets/event/champ2025/img37.jpg"),
        ]
      },
    ]
  };
}

